<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-justify">
          <v-card-text>
              <v-container>

<h1>Perguntas Frequentes</h1>

<h3>1) Quero cadastrar uma nova atividade de extensão. O que devo fazer?</h3>
As orientações passo a passo para cadastro estão disponíveis no vídeo <a href="https://www.youtube.com/watch?v=rvtSEbetxuw">em nosso canal</a>.


<h3>2) Em que época do ano posso cadastrar uma nova ação de extensão? Preciso aguardar o edital?</h3>
A PROEX recebe os pedidos de registro bem como os relatórios de atividade em fluxo contínuo, durante o ano inteiro.


<h3>3) Preciso importar meu projeto ativo do SIEX. O que devo fazer?</h3>
As orientações passo a passo para importação <a href="https://www.youtube.com/watch?v=jj2T5ktjbYc">em nosso canal</a>.


<h3>4) Quais são as ações de extensão que devem ser importadas para o Portal de Projetos? Quem faz essa importação?</h3>
Todos os programas e projetos “Ativos” no sistema Siex deverão ser importados para o <a href="https://projetos.ufes.br/#/inicio">Portal de Projetos</a>. A importação deverá ser feita pelo próprio coordenador com seu login e senha da UFES.


<h3>5) O meu projeto (e/ou programa) está expirado no Siex, entretanto, continuo desenvolvendo atividades e os meus relatórios estão atualizados. O que fazer para importá-lo para o novo sistema?</h3>
Nesse caso, o coordenador deve cadastrar a atividade como “Novo Projeto”, clicar em “submeter à aprovação” e em seguida, abrir um chamado de suporte no botão “Ajuda” (faixa preta na parte superior da tela), informando o precedimento realizado. A PROEX se responsabilizará pela ativação do projeto ou programa.


<h3>6) Ao importar meu projeto, todos os dados serão migrados?</h3>
Durante a importação, apenas o título da atividade, a data de início, a data de conclusão e o coordenador são importados, os demais dados deverão ser transcritos do Siex ou preenchidos.


<h3>7) Importei meu projeto para o novo portal, mas ele permanece com a situação “preenchimento incompleto”, o que devo fazer para que ele fique com a situação “ativo”?</h3>
O coordenador deve preencher todos os campos obrigatórios, transcrevendo as informações, conforme constam no Siex e clicar no botão “concluir importação” (abaixo, à esquerda da tela).


<h3>8) Qual o tamanho máximo dos arquivos que podem ser incluídos na aba “Arquivos”?</h3>
Vídeos – até 100 Mega<br>
Demais arquivos – até 5 Mega


<h3>9) Como faço para imprimir o espelho da proposta?</h3>
O Coordenador deve clicar no botão “Espelho da Proposta” (abaixo, à esquerda da tela). Ao gerar o documento, abrir a caixa de impressão (clicar simultaneamente em ctrl+p ou clicar sobre o documento com o botão direito do mouse e selecionar a opção “imprimir”) e salvar o arquivo como PDF.


<h3>10) Não consigo alterar a data de conclusão do projeto importado. Como proceder?</h3>
A alteração da data de conclusão é competência da PROEX, mediante aprovação da Câmara de Extensão. A renovação do projeto (ou do programa) deve ser solicitada em campo específico do formulário de relatório. O modelo está disponível em <a href="http://proex.ufes.br/formularios">formulários</a>.<br>
Após o preenchimento, é necessário autuar o relatório como processo digital na secretaria do setor de lotação do coordenador e tramitar para a PROEX.<br>
Projetos/Programas de extensão que tenham duração superior a 12 meses, deve-se apresentar relatório anual.



<h3>11) Apareceram mensagens em vermelho indicando algum tipo de erro no sistema. Como devo proceder?</h3>

No próprio <a href="https://projetos.ufes.br/#/inicio">Portal de Projetos</a> existe o botão “Ajuda” (faixa preta na parte superior da tela). O coordenador deverá clicar nesse botão e em seguida, clicar no link “sistema de suporte”. Você será direcionado para uma página na qual poderá relatar o problema. Destacamos que o andamento do chamado poderá ser feito através do link <a href="https://redmine.ufes.br/#/inicio">redmine.ufes.br</a>, e que a resposta será direcionada ao seu e-mail oficial da UFES.

<h3>12) Ainda tem Dúvidas?</h3>

Entre em contato com a Divisão de Suporte a Projetos: suporte.proex@ufes.br


            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'ajuda'
  }
</script>

<style>
  h3 {
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// faq.vue?2d86bc43